import { gql } from '@apollo/client';

export const fetchOverdueInvoicesForHomePageInPPC = gql`
  query fetchOverdueInvoicesForHomePageInPPC(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: FilterOption
  ) {
    transactionAccount(id: $id) {
      id
      overdueInvoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          transactionAccountId
          invoiceNumber
          dueDate
          shipTo {
            fullName
          }
          paymentCurrency
          total
          appliedBalance
        }
      }
    }
  }
`;
